var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"circle-slider-text"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.computedTitle)}}),_vm._v(" "),(_vm.activeDomain !== 'nexdrive_co_uk')?_c('span',{staticClass:"emphasize period-text",class:`current-step-${_vm.currentStep}`},[_vm._v(_vm._s(_vm.timePeriod))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }